export enum ColumnTypeEnum {
    String = 0,
    Action = 1,
    Model = 2,
    PhotoModel = 3,
    CheckBox = 4,
    Status = 5,
    StatusCustom = 6,
    Date = 7,
    ArrayModel = 8,
    ArrayPhotoModel = 9,
    Amount = 10,
    SubModel = 11,
    SubPhotoModel = 12,
    SubStatus = 13,
    LastActive = 14,
    InlineEditingString = 15,
    InlineEditingDropdown = 16,
    FileSize = 17,
    StatusCustomArray = 18,
    TimeSpent = 19,
    ValueInSubModel = 20,
    BackupString = 21,
    CustomUserInputFromConfig = 22,
    ValueInArrayFirstIndex = 23,
    AssigneeArray = 24
}